import {pathWithoutRegion, regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

export default {
    methods: {
        regionRelativeUrl,
        pathWithoutRegion,
    },
}
